import { useState } from 'react'

export default function usePopover(){
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return{
        anchorEl,
        setAnchorEl,
        open,
        id
    }
}